<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch02"></a><a id="page_2"></a><a href="#/contents#ch02"><b>One &amp; Only</b></a></h2>
<p class="noindent"><span>Colorado is the only state to have turned down the opportunity to host the Olympics, in 1976.</span></p>
<p class="noindent"><span>The only player in the Los Angeles Dodgers’ starting lineup with a batting average of .300 or better going into the 1965 World Series was pitcher Don Drysdale.</span></p>
<p class="noindent"><span>Only cats born with no tail: the Manx. The breed carries a genetic mutation that causes the abnormality.</span></p>
<p class="noindent"><span>Only all-female African American military unit to deploy to Europe during World War II: the 888th Central Postal Directory Battalion, out of Georgia. They sorted and delivered mail to soldiers.</span></p>
<p class="noindent"><span>Frank Zappa’s only Top-40 song: “Valley Girl,” in 1982 (it reached #32).</span></p>
<p class="noindent"><span>Only player to get caught stealing to end the World Series: Babe Ruth, in 1926.</span></p>
<p class="noindent"><span>According to <i>Billboard</i>, only two songs with the word “summer” in the title have reached number one: “Summer in the City” and “Theme from a Summer Place.”</span></p>
<p class="noindent"><span>Only Norwegian band with international success: a-ha. Biggest hit: “Take on Me.”</span></p>
<p class="noindent"><span>Michelangelo signed only one of his sculptures—the <i>Pietà</i>.</span></p>
<p class="noindent"><span>Only golfer to spend 30 minutes on a single hole in the U.S. Open: Ray Ainsley (1938).</span></p>
<p class="noindent"><span>The only member of Pink Floyd to play on every one of the band’s albums: drummer Nick Mason.</span></p>
<p class="noindent"><span>Shirley Bassey is the only artist to have recorded songs for more than one James Bond movie (<i>Goldfinger</i>, <i>Diamonds Are Forever</i>, and <i>Moonraker</i>).</span></p>
<p class="noindent"><span>The only horse to defeat Man o’ War was named Upset.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?54861ed8